/* eslint-disable no-mixed-spaces-and-tabs */
import React, { Component } from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import ResourcesPage from '../Pages/Resources/Resources';
import UsersPage from '../Pages/Users/Users';
import UserEditPage from '../Pages/Users/UserEdit/UserEdit';
import UserAddPage from '../Pages/Users/UserAdd/UserAdd';
import SchedulePage from '../Pages/SchedulePage/SchedulePage';
import RoomsPage from '../Pages/Rooms/Rooms';
import NotFoundPage from '../Pages/NotFound/NotFound';
import ResourcesEditPage from '../Pages/Resources/ResourcesEdit/ResourcesEdit';
import ResourcesAddPage from '../Pages/Resources/ResourceAdd/ResourceAddPage';
import RoomsEditPage from '../Pages/Rooms/RoomsEdit/RoomsEdit';
import AddRoomPage from '../Pages/Rooms/RoomAdd/AddRoomPage';
import FloorsPage from '../Pages/Floors/Floors';
import AddFloorPage from '../Pages/Floors/FloorAdd/FloorAdd';
import FloorsEditPage from '../Pages/Floors/FloorsEdit/FloorsEdit';
import BuildingsPage from '../Pages/Buildings/Buildings';
import AddBuildingPage from '../Pages/Buildings/BuildingAdd/BuildingAdd';
import BuildingsEditPage from '../Pages/Buildings/BuildingsEdit/BuildingsEdit';
import LoginPage from '../Pages/Login/Login';
import UTKLoginPage from '../Pages/Login/UTKlogin';
import SSOLoginSuccess from '../Pages/Login/SSOLoginSuccess';
import PrivateRoute from './PrivateRoute';
import Historical from '../Pages/Search/historical';
import AccountsPage from '../Pages/Accounts/Accounts';
import AddAccountPage from '../Pages/Accounts/AccountAdd/AccountAdd';
// @ts-ignore
import AccountsEditPage from '../Pages/Accounts/AccountsEdit/AccountsEdit.js';

const path = process.env.REACT_APP_BUILDPATH;
///let isAdmin = JSON.parse(localStorage.getItem("isAdmin")) || false;

export default class RoutingConfig extends Component {

	render() {
	 return (
			<Router basename={path}>
				<Switch>
					<Route
						exact
						path="/login"
						render={({ location }) => <LoginPage />}
					/>
					<Route
						exact
						path="/utk"
						render={({ location }) => <UTKLoginPage />}
					/>
					<Route
						exact
						path="/ssosuccess"
						component={SSOLoginSuccess}
					/>
				
					<PrivateRoute
						exact
						path="/schedule"
						component={SchedulePage}
					/>

				  <PrivateRoute exact path="/resources"
						component={() => (JSON.parse(localStorage.getItem("isAdmin")) || JSON.parse(localStorage.getItem("isSuperman")))?<ResourcesPage/> : <NotFoundPage/>}
					/> 
					<PrivateRoute exact path="/resources/add"
					 component={() => (JSON.parse(localStorage.getItem("isAdmin")) || JSON.parse(localStorage.getItem("isSuperman")))?<ResourcesAddPage/> : <NotFoundPage/>}
					/>
					<PrivateRoute exact path="/resources/:id"
						component={() => (JSON.parse(localStorage.getItem("isAdmin")) || JSON.parse(localStorage.getItem("isSuperman")))?<ResourcesEditPage/> : <NotFoundPage/>}
					/>
					<PrivateRoute
						exact
						path="/users"
						component={() => (JSON.parse(localStorage.getItem("isAdmin")) || JSON.parse(localStorage.getItem("isSuperman")))?<UsersPage/> : <NotFoundPage/>}
					/>
					<PrivateRoute
						exact
						path="/users/add"
						component={() => (JSON.parse(localStorage.getItem("isAdmin")) || JSON.parse(localStorage.getItem("isSuperman")))?<UserAddPage/> : <NotFoundPage/>}
					/>
					<PrivateRoute
						exact
						path="/users/:id"
						component={() => (JSON.parse(localStorage.getItem("isAdmin")) || JSON.parse(localStorage.getItem("isSuperman")))?<UserEditPage/> : <NotFoundPage/>}
					/>
					<PrivateRoute
						exact
						path="/buildings"
						component={() => (JSON.parse(localStorage.getItem("isAdmin")) || JSON.parse(localStorage.getItem("isSuperman")))?<BuildingsPage/> : <NotFoundPage/>}
					/>
					<PrivateRoute
						exact
						path="/buildings/add"
						component={() => (JSON.parse(localStorage.getItem("isAdmin")) || JSON.parse(localStorage.getItem("isSuperman")))?<AddBuildingPage/> : <NotFoundPage/>}
					/>
					<PrivateRoute
						exact
						path="/buildings/:id"
						component={() => (JSON.parse(localStorage.getItem("isAdmin")) || JSON.parse(localStorage.getItem("isSuperman")))?<BuildingsEditPage/> : <NotFoundPage/>}
					/>
					<PrivateRoute
						exact
						path="/floors"
						component={() => (JSON.parse(localStorage.getItem("isAdmin")) || JSON.parse(localStorage.getItem("isSuperman")))?<FloorsPage/> : <NotFoundPage/>}
					/>
					<PrivateRoute
						exact
						path="/floors/add"
						component={() => (JSON.parse(localStorage.getItem("isAdmin")) || JSON.parse(localStorage.getItem("isSuperman")))?<AddFloorPage/> : <NotFoundPage/>}
					/>
					<PrivateRoute
						exact
						path="/floors/:id"
						component={() => (JSON.parse(localStorage.getItem("isAdmin")) || JSON.parse(localStorage.getItem("isSuperman")))?<FloorsEditPage/> : <NotFoundPage/>}
					/>
					<PrivateRoute
						exact
						path="/rooms"
						component={() => (JSON.parse(localStorage.getItem("isAdmin")) || JSON.parse(localStorage.getItem("isSuperman")))?<RoomsPage/> : <NotFoundPage/>}
					/>
					<PrivateRoute
						exact
						path="/rooms/add"
						component={() => (JSON.parse(localStorage.getItem("isAdmin")) || JSON.parse(localStorage.getItem("isSuperman")))?<AddRoomPage/> : <NotFoundPage/>}
					/>
					<PrivateRoute
						exact
						path="/rooms/:id"
						component={() => (JSON.parse(localStorage.getItem("isAdmin")) || JSON.parse(localStorage.getItem("isSuperman")))?<RoomsEditPage/> : <NotFoundPage/>}
					/>
					<PrivateRoute
						exact
						path="/"
						component={SchedulePage}
					/>
					<PrivateRoute
						exact
						path="/search"
						component={() => (JSON.parse(localStorage.getItem("isAdmin")) || JSON.parse(localStorage.getItem("isSuperman"))) ?<Historical/> : <NotFoundPage/>}
					/>		
					<PrivateRoute
						exact
						path="/accounts"
						component={() => JSON.parse(localStorage.getItem("isSuperman")) ?<AccountsPage/> : <NotFoundPage/>}
					/>	
					<PrivateRoute
						exact
						path="/accounts/add"
						component={() => JSON.parse(localStorage.getItem("isSuperman"))?<AddAccountPage/> : <NotFoundPage/>}
					/>
					<PrivateRoute
   					    exact
						path="/accounts/:id"
						component={() => JSON.parse(localStorage.getItem("isSuperman"))?<AccountsEditPage/> : <NotFoundPage/>}
					/>
					<PrivateRoute component={NotFoundPage} />
				</Switch>

			</Router>
		);
	}
}



// WEBPACK FOOTER //
// ./src/Routing/RoutingConfig.js